export default __webpack_public_path__ + "static/media/2.56bc91f2.png";